export default __webpack_public_path__ + "4f4f0b4d71ba2ff8611b2bf7cf3db537.webp";